import Cookie from 'js-cookie';
import { CookieKeys } from '../constants';
import { UserType } from '../types';

export const clearStorage = () => {
  Cookie.remove(CookieKeys.TOKEN);
  Cookie.remove(CookieKeys.ONBOARDING_COMPLETE);
  Cookie.remove(CookieKeys.USER_TYPE);
  Cookie.remove(CookieKeys.REDIRECT_ROUTE);
  Cookie.remove(CookieKeys.ORG_UUID);
  Cookie.remove(CookieKeys.IS_EXPRESS_REGISTRATION);
  localStorage.clear();
  sessionStorage.clear();
};

export const getAuthToken = () => Cookie.get(CookieKeys.TOKEN);

export const setAuthToken = (token: string) =>
  Cookie.set(CookieKeys.TOKEN, token);

export const getAuthUserType = () => Cookie.get(CookieKeys.USER_TYPE);
export const setAuthUserType = (userType: UserType) =>
  Cookie.set(CookieKeys.USER_TYPE, userType);

export const getAuthOrgUuid = () => Cookie.get(CookieKeys.ORG_UUID);
export const setAuthOrgUuid = (uuid: string) =>
  Cookie.set(CookieKeys.ORG_UUID, uuid);
export const removeAuthOrgUuid = () => Cookie.remove(CookieKeys.ORG_UUID);

export const getOnboardingComplete = () =>
  Cookie.get(CookieKeys.ONBOARDING_COMPLETE);
export const setOnboardingComplete = (isComplete: 'true' | 'false') =>
  Cookie.set(CookieKeys.ONBOARDING_COMPLETE, isComplete);

export const setRedirectRoute = (pathname: string) =>
  sessionStorage.setItem(CookieKeys.REDIRECT_ROUTE, pathname);

export const getRedirectRoute = () => {
  const val = sessionStorage.getItem(CookieKeys.REDIRECT_ROUTE);

  return val;
};
